'use client'

import type { ProductIdentifierProps } from '@maestro/commerce-blocks/components/product-identifier/product-identifier.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'

import { theme } from '@maestro/local/theme'

import '@maestro/commerce-blocks/components/product-identifier/styles/product-identifier.scss'

export default function ProductIdentifier(props: ProductIdentifierProps) {
  const { product, className, items: itemsProp } = props
  const t = useTranslations('commerce-blocks')
  const { identifierItemsListings } = theme().product

  const items = (itemsProp ?? identifierItemsListings)
    .map((item) => {
      return {
        labelKey: item.labelKey,
        value: 'field' in item ? product?.[item.field] : item.value,
      }
    })
    .filter((item) => {
      return typeof item.value === 'string' && item.value
    })

  if (!items.length) {
    return null
  }

  return (
    <div className={classNames('product-identifier', className)}>
      {items.map(({ labelKey, value }) => (
        <span key={labelKey} className="product-identifier__item">
          <span className="product-identifier__item-label">{t(labelKey)}</span>
          <span className="product-identifier__item-value">
            {String(value)}
          </span>
        </span>
      ))}
    </div>
  )
}
